import { render, staticRenderFns } from "./PmsBadge.vue?vue&type=template&id=6aa69a48"
import script from "./PmsBadge.vue?vue&type=script&lang=js"
export * from "./PmsBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports